export default __webpack_public_path__ + "static/media/dmh-tostacion.60e41575.png";